import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M1 12v-.01q0-.51.06-.99c.47-3.79 3.59-6.75 7.44-6.97a4.2 4.2 0 0 1 1 0c3.86.22 6.97 3.19 7.44 6.98.04.32.06.66.06.99H1m16 3v1H1v-1h16m.09-2a1 1 0 0 0 .91-.99V12c0-4.79-3.77-8.72-8.5-8.99V1h1a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1h1v2.01C3.77 3.27.01 7.2 0 11.99V12c.01.55.45 1 1 1h7.5v1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H9.5v-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }